import React from "react";
import {
  guidelinePageTabs,
} from "./guidelineTabs";

const TabGroup = React.lazy(() => import("../../components/TabGroup/TabGroup"));

const GuidelineLandingPage = () => {
  const [tabs, setTabs] = React.useState(guidelinePageTabs);

  return (
    <>
      {tabs && (
        <TabGroup
          key={tabs.map((t) => t.id).join("-")}
          tabs={tabs}
          defaultId={tabs[0].id}
        />
      )}
    </>
  );
};

export default GuidelineLandingPage;